import { Button } from '@mui/material'
import { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'

function ContactSupportButton({ style }: { style?: CSSProperties }) {
    const { t } = useTranslation()

    return (
        <Button
            onClick={() => window.open('mailto:support@orderwire.com')}
            color="info"
            style={style}
        >
            {t('license.button.contact')}
        </Button>
    )
}

export default ContactSupportButton
